<template>
    <div class="anti-fraud">
        <div class="anti-fraud-img">
<!--            <img src="/anti_fraud/anti-fraud-main.png" >-->
        </div>
        <div class="main">
            <div class="main-img">
                <img src="/anti_fraud/anti-fraud-title.png" >
            </div>
            <h3>各位用户：</h3>
            <div class="main-title-text">
                <p>大家好！本平台自成立以来，便矢志不渝地致力于协助广大中国人实现幸福婚姻的梦想，为众多单身男女解决婚恋难题。我们倾力打造一个真实、严谨的交友平台，矢志守护每位用户的个人权益。然而，遗憾的是，仍有人企图利用用户的真挚情感进行欺诈，不仅给用户的情感世界带来伤害，更导致经济损失。</p>
                <p>多年来，本平台与网络诈骗分子进行了不懈的斗争，期间我们总结了一些骗子常用的欺诈手段，现特与大家分享。我们诚挚地希望，每位用户都能提高警惕，增强防范意识。一旦遭遇诈骗，请务必及时报警或向我们举报，让我们携手并肩，共同打击这些可耻的诈骗行为，维护一个安全、健康的交友环境。</p>
                <p>《中华人民共和国反电信网络诈骗法》<span style="color: #E60012;">共七章50条，包括总则、电信治理、金融治理、互联网治理、综合措施、法律责任、附则等</span>，坚持以人民为中心，统筹发展和安全，立足各环节、全链条防范治理电信网络诈骗，精准发力，为反电信网络诈骗工作提供有力法律支撑。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                <div class="content-title-text"> <div class="content-black"> </div>第一条 杀猪盘诈骗</div>
            </div>
            <div class="content-text">

                <p>所谓“杀猪盘”，实则是一场以恋爱婚姻为幌子的金钱诈骗阴谋。在这场游戏中，受骗者被戏称为“猪仔”，而骗子则通过精心编织的“恋爱剧本”，逐步将受害者引入陷阱，这一过程被形象地称为“养猪”，最终实施诈骗的那一刻，便是“杀猪”。这些不法分子往往利用虚假的身份，配以精心挑选的“型男靓女照”和无微不至的关怀，一步步瓦解受害者的心理防线。</p>
                <p>起初，他们可能会让受害者尝到一些甜头，赚取一些小钱，但当受害者彻底放下戒备，便会被引入一个个看似高回报实则危机四伏的陷阱，最终损失惨重。</p>
                <p>“杀猪盘”的诈骗流程通常如下：</p>
                <p>骗子通过社交软件精心筛选目标。添加受害者社交软件，通过无微不至的关怀迅速建立信任，进而发展为恋爱关系。</p>
                <p>通过各种手段套取受害者的家庭背景、情感状况及财务状况。假装不经意间透露自己掌握某投资平台的漏洞，已获取巨额收益，以此激发受害者的好奇心。</p>
                <p>引导受害者投资，并让其初尝甜头，获取小额利润。不断诱导受害者追加投资，当受害者出现亏损时，骗子则以各种理由搪塞，称这只是意外。</p>
                <p>当受害者资金枯竭或意识到被骗时，骗子便矢口否认诈骗行为，并拉黑受害者的联系方式。</p>
                <p>“杀猪盘”不仅是财产的掠夺，更是情感的欺骗。许多受害者在被骗许久后，仍沉浸在虚假的“爱情童话”中无法自拔。为防止“杀猪盘”诈骗，请务必牢记以下几点：</p>
                <p>切勿轻信任何所谓的“内部消息”或“系统漏洞”进行理财、赌博等投资。</p>
                <p>对那些炫耀自己投资获取丰厚回报的人保持高度警惕。</p>
                <p>对于过分热情、主动的人，要提高防骗意识。</p>
                <p>若对方以各种理由拒绝见面，但频繁谈论婚姻、未来，给予无限希望及憧憬，务必提高警惕，以防上当受骗。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                <div class="content-title-text"> <div class="content-black"> </div>第二条 借贷诈骗</div>
            </div>
            <div class="content-text">
                <p>在人际交往的广阔天地里，单身朋友们需格外留神骗子们惯用的几种借口，以保护自身免受欺诈。以下是一些常见的欺诈手段，请大家在与陌生人交往时多加警惕：</p>
                <p>有的女性可能会编织谎言，声称自己因经济拮据而无法继续学业，急需好心人的经济援助来圆自己的求学梦。</p>
                <p>另一些情况下，男性可能会假冒海外归来的精英，编造自己身患重病或遭受政治迫害的虚假故事，以此博取女性的同情，并请求其提供经济上的支持。</p>
                <p>还有的女性会谎称自己的父母或家人身患重病，急需资金进行医疗救治，从而向他人寻求紧急帮助。</p>
                <p>此外，有些男性还会冒充成功的企业老板，虚构资金周转困难或钱包遗失的情境，向女性提出借款的请求。</p>
                <p>更有甚者，在约会过程中，骗子可能会突然来电，谎称自己在途中遭遇车祸，急需用钱，并要求对方将款项打入自己的银行账户。</p>
                <p>面对这些层出不穷的欺诈手段，单身朋友们在与他人交往时务必保持清醒的头脑，提高警惕，以免落入骗子的圈套。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第三条 股票诈骗</div>
            </div>
            <div class="content-text">
                <p>犯罪分子常常利用“委托投资、专业推荐、高额回报”等诱人幌子，吸引受害者的目光。他们先是通过小额返利，巧妙骗取受害者的信任，随后便以验资、会员费、信息费、保证金等各种名目，要求受害者汇款。一旦诈骗得手，他们便迅速切断与受害者的所有联系，消失得无影无踪。</p>
                <p>面对这样的陷阱，我们必须时刻保持警惕，摒弃“高额回报”、“无风险利润”等不切实际的暴富心态。树立正确的投资观念，理性看待投资回报，不盲目追求高额收益，是避免陷入诈骗陷阱、远离不必要风险和损失的关键。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第四条 博彩诈骗</div>
            </div>
            <div class="content-text">
                <p>犯罪分子将贪婪的目光锁定在彩民群体上，他们精心编织谎言，声称能提供所谓的“内部信息”和“权威预测”，大肆吹嘘自己过往的预测“战绩”，以短期获取暴利的博彩信息作为诱饵。这些骗子打着“稳赚不赔”和“独家内幕”的幌子，先是通过给予彩民一些小甜头，承诺保证中奖，以此逐步建立起信任。随后，他们便利用彩民急于翻本的心理，一次次地诈骗彩民的钱财。</p>
                <p>对于那些声称能预测博彩内幕、中奖特码等信息，我们必须保持清醒的头脑，明辨真伪。切勿轻信所谓的“内幕资料”等不实信息，更不要有一夜暴富的贪欲心理和侥幸心理。我们应该坚决杜绝参与任何非法赌博活动，以免陷入骗子的陷阱，造成不可挽回的经济损失。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第五条 传销诈骗</div>
            </div>
            <div class="content-text">
                <p>不法分子往往以特定年龄段为伪装，男性多登记在44至55岁之间，女性则集中在24至28岁，他们自称拥有稳定的工作和丰厚的收入。这些不法之徒主要针对年龄在25岁以上、具备独立经济能力的网友，实施传销诈骗活动。他们利用精心挑选的照片和高收入的虚假描述来迷惑目标对象，随后以见面为由，诱导受害人参加传销培训，并不断诱骗其支付加盟费用，或者强迫其发展新的下线成员。</p>
                <p>在此，提醒单身朋友们在网络交友过程中务必保持高度警惕。对于那些在网络上初次接触就自称成熟稳重、事业有成、月收入可观的成功男士，以及那些频繁使用美艳照片来吸引注意的女性，要格外小心。切勿在尚未深入了解对方真实情况的情况下，轻易相信对方的承诺，以免落入诈骗的陷阱之中。保持理智和谨慎，是保护自己免受不法侵害的关键。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第六条 酒托饭托</div>
            </div>
            <div class="content-text">
                <p>首先，酒吧托与饭托这一角色，通常由女性扮演，且她们在网络平台上展示的照片往往颇为迷人。在初次建立联系时，无论是她们发出的第一封信还是回复的第一封信，往往就迫不及待地附上联系方式，或是直接索求男性的联系方式，如手机号码、QQ号、MSN等。</p>
                <p>紧接着，在双方取得联系后不久，女方通常会迅速表现出愿意或主动提出与男方见面约会的意愿，并且会明确指定某个酒吧或其他娱乐场所作为约会的地点。这类酒托或饭托正是利用了单身男士的好感与期待，诱导他们前往特定的娱乐场所进行消费，并从中与该场所分享消费收益，以此作为谋生的手段。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第七条 花篮托</div>
            </div>
            <div class="content-text">
                <p>主要以30至50岁的男性为目标群体，他们在个人资料中常标榜自己事业有成；同时，也存在一部分女性，她们在资料中描述自己经历了感情的风雨，渴望找到一位可靠的伴侣共度余生。这类人群首先会打着婚恋交友的幌子，频繁地与其他征友对象保持联系，每日发送多条短信和拨打电话，急于与对方确立亲密关系，以此来骗取对方的信任。</p>
                <p>接着，骗子会精心安排所谓的“亲戚”角色登场，通过这位“亲戚”的展示，让征友对象对其身份、社会地位以及财力状况深信不疑。随后，骗子便会以公司开业庆典或店面开张为由，要求对方前往指定的花店购买花篮，或是直接向其账户汇款。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第八条 机票托</div>
            </div>
            <div class="content-text">
                <p>这类不法分子往往以团伙形式活动，其中一人专门负责与征友对象建立联系并逐步获取其信任。经过一段时间的交往后，该不法分子会声称将乘坐飞机前往看望对方或出差。随后，他们会打来电话，编造钱包被盗等虚假理由，要求联系人汇款以购买机票。为了增强可信度，他们还会利用事先录制好的机场背景音频来迷惑联系对象。与此同时，团伙内的其他成员则扮演机场工作人员或其他相关角色，与联系人通话，进一步骗取信任，以达到其诈骗钱财的最终目的。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第九条 投资炒期货</div>
            </div>
            <div class="content-text">
                <p>不法分子常常伪装成成功人士，在与潜在受害者建立联系后，他们会通过一段时间的嘘寒问暖和交往，逐渐建立起信任关系。接着，他们会以提供帮助或建议的名义，诱导对方在一个特定的网络平台进行期货或现货投资（这些往往并非正规或合格的理财产品）。不法分子会夸大其词，声称自己正是通过这个平台投资获得了巨大的收益。</p>
                <p>然而，当受害者进行投资后，往往会面临亏损。此时，不法分子并不会就此罢休，而是会继续编织谎言，将责任归咎于平台指导老师的选择不当，并再次推荐一位所谓的“优秀”指导老师，承诺这次一定能赚钱。然而，无论受害者进行多少次投资，最终的结果都是血本无归。</p>
                <p>因此，单身朋友们在网络交友和投资过程中务必提高警惕，切勿轻信他人的投资建议和承诺，以免上当受骗。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第十条 中奖圈套</div>
            </div>
            <div class="content-text">
                <p>骗子利用网站留言的方式，向广大用户散布虚假的诈骗信息，内容诸如：“恭喜您，您的账号已被系统随机抽中，荣获由平台赠送的惊喜奖金X万元及XXX品牌笔记本电脑一台。活动验证码已发送至您的账户，请妥善保管。这些骗子精心伪造的网站网址与本平台的官方网址极为相似，极具迷惑性。</p>
                <p>本平台在此郑重提醒所有单身朋友：本平台举办的任何抽奖活动，均会通过官方网站正式发布，并在站内设有明确的网页标识，活动细则公开透明。获奖者的名单也会在本平台上进行公示，我们不会以任何理由向获奖者收取邮递费、税金、手续费等额外费用。请大家务必提高警惕，仔细甄别，切勿轻信此类诈骗信息，以免上当受骗。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第十一条 丧偶成功人士</div>
            </div>
            <div class="content-text">
                <p>在广州、香港等地，有一些自诩为单身或丧偶的成功男士，频繁地浏览众多单身女性用户的个人主页，并在极短的时间内向她们大量发送交友信息。一旦收到对方的回复，他们便开始深情地讲述自己寻找伴侣的真诚愿望或是丧偶后的不幸遭遇，以此逐渐赢得对方的信任与好感。然而，这只是他们精心设计的骗局的一部分。在成功获取对方信任后，他们便会开始实施骗取钱财的行动，导致许多单身女性因此遭受经济损失。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第十二条 高额声讯电话</div>
            </div>
            <div class="content-text">
                <p>这类不法分子常常在个人资料中故意留下高额收费的声讯电话号码，作为他们的联系方式。在邮件往来中，他们还会主动提供这个电话号码，诱导他人拨打。值得注意的是，这些不法分子往往不会主动出击，而是采取守株待兔的策略，等待他人上钩，主动拨打他们留下的电话号码。而一旦拨打了这个电话，就会产生高昂的费用。因此，单身朋友们在网络交友过程中，对于这类情况务必保持高度警惕，以免落入陷阱，遭受不必要的经济损失。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                
                <div class="content-title-text"> <div class="content-black"> </div>第十三条 香港赛马会</div>
            </div>
            <div class="content-text">
                <p>这类骗子的账号注册地多集中在广州、香港等地，他们在与征友对象建立联系后，会迅速索要QQ、MSN等即时通讯工具的联系方式。经过一段时间的沟通与交流，一旦成功获取了对方的信任，他们便会谎称自己是某个赛马协会的工作人员，拥有赛马比赛的内幕消息。接着，他们会以此为诱饵，引诱目标对象进行巨额的投资。然而，事实上，这个所谓的赛马协会根本就不存在，完全是他们编造出来的谎言。</p>
            </div>
        </div>

        <div class="content">
            <div class="content-title">
                <div class="content-title-text"> <div class="content-black"> </div>第十四条 家境贫寒博取同情</div>
            </div>
            <div class="content-text">
                <p>这类骗子在聊天过程中常常刻意营造一种家境贫寒、生活困顿的形象，以此来触动征友对象的恻隐之心，博取同情与信任。一旦他们成功地在对方心中树立起这样的形象，并完全赢得了对方的信任，便会开始展露自己的“理想与抱负”，同时表达出希望得到征友对象资金支持的意愿，并会用甜言蜜语许下种种承诺。然而，一旦骗取了资金，他们就会迅速将对方拉黑，消失得无影无踪。</p>
                <p>值得注意的是，这类骗子在征友过程中总是拒绝线下见面，只通过网络和电话的方式与对方联系。因此，请大家务必提高警惕，避免落入此类骗局的陷阱。</p>
            </div>
        </div>


        <div class="content" style="padding-top: 25px; margin-bottom: 30px;">
            <div class="content-text">
                <p>骗子的手段虽日新月异，变幻莫测，但正所谓“道高一尺，魔高一丈”。始终不遗余力，从技术创新到人力投入，全方位、多角度地严厉打击诈骗行为，确保骗子无处遁形。对于针对付费会员的欺诈行为，我们更是采取零容忍态度，坚决查处，绝不姑息。我们的目标，是打造一个真实、纯净的交友环境，让每一位单身男女都能在此安心寻觅缘分，远离欺骗与伤害。</p>
            </div>
        </div>

        <!-- <div class="footer">    
            <div class="footer-white">
                <p>骗子的手段虽日新月异，变幻莫测，但正所谓“道高一尺，魔高一丈”。始终不遗余力，从技术创新到人力投入，全方位、多角度地严厉打击诈骗行为，确保骗子无处遁形。对于针对付费会员的欺诈行为，我们更是采取零容忍态度，坚决查处，绝不姑息。我们的目标，是打造一个真实、纯净的交友环境，让每一位单身男女都能在此安心寻觅缘分，远离欺骗与伤害。</p>
            </div>
        </div> -->
    </div>
    <!--回到顶部-->
<!--    <van-back-top style="background-color: #E60012"/>-->
    <van-back-top class="custom"><img src="/back_top.png"  alt="回到顶部"></van-back-top>
</template>

<style lang="scss" scoped>
.anti-fraud {
    width: 100%;
    min-height: 300px;
    background-color: #f1f1f1;
    .anti-fraud-img {
        background-image: url('~@/assets/anti-fraud-main.png');
        //background-size: contain;
        background-size: 100% auto;
        background-repeat: no-repeat;
        width: 100%;
        height: 750px;
        //img {
        //    width: 100%;
        //}
    }
    .main {
        padding: 20px;
        margin: 15px 10px 0 10px;
        text-align: left;
        background-color: #fff;
        .main-img {
            width: 100%;
            margin-top: 15px;
            img {
                width: 100%;
            }
        }
        .main-title-text {
            // margin: 20px;
        }
        border-radius: 25px;
    }
    .main-tips {
        text-align: left;
        margin-left: 10px;
        margin-right: 10px;
        background-color: #E60012;
        border-radius: 25px;
        padding: 10px;
        color: #fff;
        p {
            color: #fff;
        }
    }
    .content {
        background-color: #fff;
        min-height: 100px;
        border: 1px dashed #fff;
        border-radius: 25px;
        margin-top: 15px;
        margin-left: 10px;
        margin-right: 10px;
        .content-title {
            width: 100%;
            margin: 20px 0;
            .content-title-text {
                font-size: 21px;
                color: #222222;
                text-align: center;
                font-weight: 600;
                .content-black{
                    display: inline-block;
                    width: 6px;
                    height: 20px;
                    background-color: #FE405F;
                    border-radius: 3px;
                    // margin-top: 8px;
                    margin-right: 10px;
                }
            }
        }
        .content-text {
            text-align: left;
            // margin-top: 20px;
            margin-left: 20px;
            margin-right: 20px;
        }
    }
    .footer {
        min-height: 100px;
        margin: 25px 10px 0 10px;

        .footer-red {
            text-align: left;
            background-color: #E60012;
            border-radius: 25px;
            padding: 10px;
            p {
                color: #fff;
            }
        }
        .footer-white {
            text-align: left;
            padding: 20px 10px;
        }
    }
}
p {
    margin-top: 5px;
    text-indent: 2em;
    line-height: 26px;
    font-size: 18px;
    color: #000000;
}
.custom{
    width: 50px;
    height: 50px;
    img{
        width: 50px;
        height: 50px;
    }
}
</style>